module.exports = __webpack_public_path__ + "img/sured.f8bdc18.png";